import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Announcement } from '../models/announcement';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'app-new-announcement-dialog',
    templateUrl: './new-announcement-dialog.component.html',
    styleUrl: './new-announcement-dialog.component.css',
    standalone: false
})
export class NewAnnouncementDialogComponent {
  announcementTypes: string[] = [];
  selectedType: string = '';
  announcementContent: string = '';
  announcementTitle: string = '';
  existingAnnouncement: any;

  constructor(public dialogRef: MatDialogRef<NewAnnouncementDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.announcementTypes = data.announcementTypes;
    this.existingAnnouncement = data.announcement;

    if(this.existingAnnouncement) {
      this.selectedType = this.existingAnnouncement.announcementType;
      this.announcementContent = this.existingAnnouncement.announcementMessage;
      this.announcementTitle = this.existingAnnouncement.announcementTitle;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submitAnnouncement(): void {
    const announcement: Announcement = {
      announcementType: this.selectedType,
      announcementMessage: this.announcementContent,
      announcementTitle: this.announcementTitle,
      announcementDate: this.existingAnnouncement?.announcementDate ?? new Date(),
      announcementId: this.existingAnnouncement?.announcementId ?? uuidv4()
    };
    this.dialogRef.close(announcement);
  }
}
